<template>
  <div class="home home-page-container">
    <div class="container">
      <div class="home-match__nav display-flex hide-mobile">
        <div
          class="match-nav__child"
          :class="{ selected: o.selected }"
          v-for="(o, index) in sportType"
          :key="index"
          @click="selectSportType(o)"
        >
          {{ o.name }}
        </div>
      </div>
    </div>
    <!-- mobile -->
    <transition name="fade">
      <div
        class="home-nav__sport-type__list-wrapper"
        v-if="mobile.isSelectSportType"
      >
        <div class="home-nav__sport-type__list-header">
          <div>Sport Type</div>
          <div @click="selectSportTypeMobile()">
            <img
              class=""
              src="../../../assets/images/icons/icon_close_white.png"
            />
          </div>
        </div>
        <div class="home-nav__sport-type__list-container">
          <div
            class="home-nav__sport-type__list-child"
            :class="{ selected: o.selected }"
            v-for="(o, index) in sportType"
            :key="index"
            @click="selectSportType(o)"
          >
            {{ o.name }}
          </div>
        </div>
        <div class="overlay" @click="selectSportTypeMobile()"></div>
      </div>
    </transition>
    <transition name="slide">
      <div class="match-filter__wrapper" v-if="mobile.isSelectMatch">
        <div class="match-filter__header">
          <div @click="selectMatch()">
            <img src="../../../../static/images/icons/icon_close_white.png" />
          </div>
          <div>{{ $t("FILTER_BY") }}</div>
          <div
            class="match-filter__tick selected"
            @click="handleFinishSelectLeague()"
          ></div>
        </div>
        <div class="match-filter__body">
          <div class="match-filter__clear">
            <span
              class="btn-primary__outline"
              @click="clearAllSelectMatchChild()"
            >
              {{ $t("CLEAR_ALL") }}
            </span>
          </div>
          <div
            class="search-mobile__wrapper"
            :class="{ selected: isFilterSearchFoucs }"
          >
            <img
              class="search-mobile__icon"
              src="../../../../static/images/icons/icon_search.png"
            />
            <input
              class="search-mobile__input"
              v-model="filter_search_txt_mobile"
              v-on:keyup="handleFilterSearchMobile()"
              @focusin="isFilterSearchFoucs = true"
              @focusout="isFilterSearchFoucs = false"
              :placeholder="$t('SEARCH_COUNTRY_OR_LEAGUE')"
            />
          </div>
          <!-- no filtering serarch text ui -->
          <div
            class="match-filter__list-wrapper"
            v-if="filter_search_txt_mobile.length === 0"
          >
            <div
              class="match-filter__list-container"
              v-for="(o, index) in filterObj"
              :key="index"
            >
              <div class="match-filter__list-title">
                {{ $t(o.categoryDisplayName) }}
              </div>
              <ul class="match-filter__list-child__wrapper">
                <li
                  class="match-filter__list-child"
                  v-for="(level2, index) in o.countries"
                  :key="index"
                >
                  <div class="match-filter__list-child__left">
                    <div class="match-filter__list-child__left-container">
                      <div
                        class="mr-05rem match-filter__list-child__left-select"
                        :class="{
                          selected: level2.selected,
                        }"
                        @click="selectMatchChildAll(o, level2)"
                      ></div>
                    </div>
                    <router-link
                      v-if="level2.rootFlag"
                      :to="{
                        path: `/${currentLocale}/${currentSportType}/${level2.countryKey}/${level2.leagueKey}`,
                        query: {
                          leagueId: level2.leagueId,
                          subLeagueId: level2.subLeagueId,
                        },
                      }"
                      class="display-flex-sb w-100"
                      target="_blank"
                    >
                      <div class="display-flex-center">
                        <Icon
                          :logoUrl="level2.logo"
                          :category="'country'"
                          class="mr-05rem"
                        >
                        </Icon>
                        <div>
                          {{ level2.countryDisplayName }}
                        </div>
                      </div>
                    </router-link>
                    <div
                      v-else
                      class="display-flex-sb w-100"
                      @click="selectMatchChild(o, level2)"
                    >
                      <div class="display-flex-center">
                        <Icon
                          :logoUrl="level2.logo"
                          :category="'country'"
                          class="mr-05rem"
                        >
                        </Icon>
                        <div>
                          {{ level2.countryDisplayName }}
                        </div>
                      </div>
                      <div class="mr-1rem">
                        <img
                          src="../../../../static/images/icons/icon_arrow_right.png"
                        />
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!-- filtering serarch text ui -->
          <div
            class="match-filter__list-wrapper"
            v-if="filter_search_txt_mobile.length > 0"
          >
            <!-- Country Section -->
            <div
              class="match-filter__list-container"
              v-show="searchCountryListMobile.length > 0"
            >
              <div class="match-filter__list-title">
                {{ $t("COUNTRY") }}
              </div>
              <ul class="match-filter__list-child__wrapper">
                <li
                  class="match-filter__list-child"
                  v-for="(o, index) in searchCountryListMobile"
                  :key="index"
                >
                  <div class="match-filter__list-child__left">
                    <div class="match-filter__list-child__left-container">
                      <div
                        class="mr-05rem match-filter__list-child__left-select"
                        :class="{
                          selected: o.selected,
                        }"
                        @click="selectMatchChildAll('', o)"
                      ></div>
                    </div>
                    <router-link
                      :to="{
                        path: `/${currentLocale}/${currentSportType}/${o.countryKey}/${o.leagueKey}`,
                        query: {
                          leagueId: o.leagueId,
                          subLeagueId: o.subLeagueId,
                        },
                      }"
                      v-if="o.rootFlag"
                      target="_blank"
                      class="display-flex-sb w-100"
                    >
                      <div class="display-flex-center">
                        <Icon
                          :logoUrl="o.logo"
                          :category="'country'"
                          class="mr-05rem"
                        ></Icon>
                        <div>
                          {{ o.countryDisplayName }}
                        </div>
                      </div>
                    </router-link>
                    <div
                      class="display-flex-sb w-100"
                      @click="selectMatchChild('', o)"
                      v-else
                    >
                      <div class="display-flex-center">
                        <Icon
                          :logoUrl="o.logo"
                          :category="'country'"
                          class="mr-05rem"
                        >
                        </Icon>
                        <div>
                          {{ o.countryDisplayName }}
                        </div>
                      </div>
                      <div class="mr-1rem">
                        <img
                          src="../../../../static/images/icons/icon_arrow_right.png"
                        />
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <!-- League Section -->
            <div
              class="match-filter__list-container"
              v-show="searchLeagueListMobile.length > 0"
            >
              <div class="match-filter__list-title">
                {{ $t("LEAGUE") }}
              </div>
              <ul class="match-filter__list-child__wrapper">
                <li
                  class="match-filter__list-child"
                  v-for="(o, index) in searchLeagueListMobile"
                  :key="index"
                >
                  <div class="match-filter__list-child__left">
                    <div
                      class="match-filter__list-child__left-container"
                      @click="selectMatchChild2(o)"
                    >
                      <div
                        class="mr-05rem match-filter__list-child__left-select"
                        :class="{
                          selected: o.selected,
                        }"
                      ></div>
                    </div>
                    <router-link
                      :to="{
                        path: `/${currentLocale}/${currentSportType}/${o.countryKey}/${o.leagueKey}`,
                        query: {
                          leagueId: o.leagueId,
                          subLeagueId: o.subLeagueId,
                        },
                      }"
                      target="_blank"
                    >
                      {{ o.countryDisplayName }}:{{ o.name }}
                    </router-link>
                  </div>
                </li>
              </ul>
            </div>
            <div
              v-show="
                searchCountryListMobile.length === 0 &&
                searchLeagueListMobile.length === 0
              "
              class="no-data"
            >
              {{ $t("MENU_NOT_AVAILABLE") }}
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="slide">
      <div class="match-filter__wrapper" v-if="mobile.isSelectMatch2">
        <div class="match-filter__header">
          <div @click="closeSelectMatch2()">
            <img src="../../../../static/images/icons/icon_arrow_left.png" />
          </div>
          <div>{{ selectLeagueLevel2 }}</div>
          <div></div>
          <!-- <div class="match-filter__tick" :class="{selected: mobile.isSelectedMatchChild}" @click="handleFinishSelectLeague()"> </div> -->
        </div>
        <div class="match-filter__body">
          <div class="match-filter__clear">
            <span
              class="btn-primary__outline"
              @click="clearAllSelectMatchChild2()"
            >
              {{ $t("CLEAR_ALL") }}
            </span>
          </div>
          <div class="match-filter__list-wrapper">
            <div class="match-filter__list-container">
              <ul class="match-filter__list-child__wrapper">
                <li
                  class="match-filter__list-child"
                  v-for="(o, index) in matchList2.soccerLeagues"
                  :key="index"
                >
                  <div class="match-filter__list-child__left">
                    <div
                      class="match-filter__list-child__left-container"
                      @click="selectMatchChild2(o)"
                    >
                      <div
                        class="mr-05rem match-filter__list-child__left-select"
                        :class="{
                          selected: o.selected,
                        }"
                      ></div>
                    </div>
                    <router-link
                      :to="{
                        path: `/${currentLocale}/${currentSportType}/${o.countryKey}/${o.leagueKey}`,
                        query: {
                          leagueId: o.leagueId,
                          subLeagueId: o.subLeagueId,
                        },
                      }"
                      target="_blank"
                    >
                      {{ o.name }}
                    </router-link>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- mobile end -->

    <!-- desktop -->
    <div>
      <!-- <Banner v-if="!isMobile"></Banner> -->
      <router-view></router-view>

      <div class="container">
        <div class="display-flex w-100">
          <div v-if="!isMobile">
            <div
              v-if="league.isLoading"
              class="match-country__wrapper skeleton-table__wrapper"
            >
              <div
                class="display-flex-sb mb-1rem"
                v-for="(o, index) in 20"
                :key="index"
              >
                <div class="skeleton-child skeleton-league__tick"></div>
                <div class="skeleton-child skeleton-league__name"></div>
              </div>
            </div>
            <div v-else class="match-country__wrapper">
              <Filter
                ref="filterRef"
                @favFilterEmit="commitParamsToMatchContent('Filter')"
              >
              </Filter>
            </div>
          </div>

          <div class="w-100">
            <div class="match-filter__wrapper-desktop">
              <div class="match-filter home-match-filter">
                <!-- weekly calendar -->
                <div class="match-filter__live-container">
                  <div
                    class="match-filter__live-wrapper"
                    @click="handleLiveMatch()"
                  >
                    <div
                      class="match-filter__live"
                      :class="{
                        'match-filter__live_light':
                          !isMobileRealTime && themeModeIndex === 'lightWeb',
                        'match-filter__live_dark':
                          !isMobileRealTime && themeModeIndex === 'darkWeb',
                        'match-filter__live_webapp':
                          isMobileRealTime && themeModeIndex === 'lightWebapp',
                        'match-filter__live_webapp_dark':
                          isMobileRealTime && themeModeIndex === 'darkWebapp',
                        selected: isLiveOnlyMatch,
                      }"
                    ></div>
                  </div>
                  <weekly-calendar
                    :params="currentDate"
                    :data="weeklyCalendarData"
                    :show="isMobile ? 3 : 2"
                    @weeklyDateChange="selectByDateWeekly($event)"
                    @isOverWeeklyDateRange="isOverWeeklyDateRange($event)"
                    @changeDate="changeDate"
                    v-if="!isMobile"
                    ref="weeklyCalendar"
                  >
                  </weekly-calendar>
                  <div class="display-flex-align-center mobile-calander">
                    <IconMode v-if="isMobile">
                      <template #default="{ index }">
                        <img
                          src="@static/images/icons/aspn_icon/date_picker/arrow_left.png"
                          v-if="index === 'lightWebapp'"
                          class="icon-arrow arrow-left"
                          @click="changeDate('prev')"
                        />
                        <img
                          src="@static/images/icons/aspn_icon/date_picker/arrow_left_dark.png"
                          v-else-if="index === 'darkWebapp'"
                          class="icon-arrow arrow-left"
                          @click="changeDate('prev')"
                        />
                      </template>
                    </IconMode>

                    <div class="display-flex">
                      <!-- v-if="isMobile" -->
                      <div class="match-filter__date">
                        <DatePicker
                          v-model="montlyCalenderModel"
                          color="#6F8C9B"
                          :is-dark="themeMode === 'dark'"
                          firstDayOfWeek="1"
                          :locale="
                            currentLocale === 'vn'
                              ? 'vi'
                              : currentLocale && currentLocale === 'cn'
                              ? 'zh'
                              : currentLocale
                          "
                        >
                          <template
                            #default="{
                              inputValue,
                              togglePopover,
                              hidePopover,
                            }"
                          >
                            <div
                              class="display-flex-align-center"
                              @click.stop="
                                monthlyCalendarHandle(
                                  $event,
                                  date,
                                  togglePopover,
                                  hidePopover
                                )
                              "
                            >
                              <div class="date-value">
                                <span v-if="isMobile">
                                  <span class="bold">
                                    {{
                                      isToday(montlyCalender.date)
                                        ? $t("TODAY")
                                        : ""
                                    }}
                                  </span>
                                  {{ datePickerDate(montlyCalender.date) }}
                                </span>
                                <IconMode>
                                  <template #default="{ index }">
                                    <img
                                      src="@static/images/icons/aspn_icon/date_picker/calender_circle.png"
                                      v-if="index === 'lightWeb'"
                                      class="icon-calender"
                                    />
                                    <img
                                      src="@static/images/icons/aspn_icon/date_picker/calender_circle_dark.png"
                                      v-else-if="index === 'darkWeb'"
                                      class="icon-calender"
                                    />
                                    <img
                                      src="@static/images/icons/aspn_icon/date_picker/calender.png"
                                      v-else-if="index === 'lightWebapp'"
                                      class="icon-calender"
                                    />
                                    <img
                                      src="@static/images/icons/aspn_icon/date_picker/calender_dark.png"
                                      v-else-if="index === 'darkWebapp'"
                                      class="icon-calender"
                                    />
                                  </template>
                                </IconMode>
                              </div>
                            </div>
                          </template>
                        </DatePicker>
                      </div>
                    </div>

                    <IconMode v-if="isMobile">
                      <template #default="{ index }">
                        <img
                          src="@static/images/icons/aspn_icon/date_picker/arrow_right.png"
                          v-if="index === 'lightWebapp'"
                          class="icon-arrow arrow-right"
                          @click="changeDate('next')"
                        />
                        <img
                          src="@static/images/icons/aspn_icon/date_picker/arrow_right_dark.png"
                          v-else-if="index === 'darkWebapp'"
                          class="icon-arrow arrow-right"
                          @click="changeDate('next')"
                        />
                      </template>
                    </IconMode>
                  </div>
                </div>
              </div>
            </div>
            <!-- fav match -->
            <MatchContent
              v-show="isLogin && isShowFavList && !isLiveOnlyMatch"
              ref="favMatchContentChild"
              class="match-content__wrapper match-fav-content__wrapper match-home-content__wrapper"
              type="homeFavList"
              @favMatchContentEvent="toggleFavList($event)"
              @updateFav="updateFav"
            >
            </MatchContent>
            <!-- match -->
            <MatchContent
              ref="matchContentChild"
              class="match-content__wrapper match-home-content__wrapper"
              type="homeList"
              @changeMatchContentEvent="changeMatchContentEvent($event)"
              @updateFav="updateFav"
            >
            </MatchContent>
          </div>

          <div
            v-if="!isMobile || !isMobileRealTime"
            class="match-table__wrapper"
          >
            <!-- desktop featured-match -->

            <div class="content-wrapper" v-show="featuredMatchList.length > 0">
              <div class="content-title">
                {{ $t("FEATURED_MATCH") }}
              </div>
              <featuredMatchListContent
                :featuredMatchList="featuredMatchList"
                :featureMatchTimer="featureMatchTimer"
              />
            </div>

            <!-- desktop ranking table -->
            <div class="match-table-standing-wrapper">
              <div
                class="match-table__title-wrapper"
                v-show="rankingTable.isShow"
              >
                <!-- <div>{{ $t("STANDINGS") }}</div> -->
                <div class="display-flex-center home-match__standing-table">
                  <div
                    class="match-table__title-arrow__wrapper tl"
                    :class="{
                      invisible: !rankingTable.isShowArrow,
                    }"
                    @click="handleLeagueListRankingTable('prev')"
                  >
                    <!-- arrow left -->
                    <IconMode>
                      <template #default="{ index }">
                        <img
                          src="@static/images/icons/aspn_icon/date_picker/arrow_left_standing.png"
                          v-if="['lightWeb', 'lightWebapp'].includes(index)"
                          class="standing-arrow"
                        />
                        <img
                          src="@static/images/icons/aspn_icon/date_picker/arrow_left_standing_dark.png"
                          v-else-if="['darkWeb', 'darkWebapp'].includes(index)"
                          class="standing-arrow"
                        />
                      </template>
                    </IconMode>
                  </div>
                  <div class="match-table__title-country">
                    <div class="match-table__title-country-container">
                      <span>{{ rankingTable.currentSelectedLeague }}</span>
                    </div>
                  </div>
                  <div
                    class="match-table__title-arrow__wrapper"
                    :class="{
                      invisible: !rankingTable.isShowArrow,
                    }"
                    @click="handleLeagueListRankingTable('next')"
                  >
                    <!-- arrow-right -->
                    <IconMode>
                      <template #default="{ index }">
                        <img
                          src="@static/images/icons/aspn_icon/date_picker/arrow_right_standing.png"
                          v-if="['lightWeb', 'lightWebapp'].includes(index)"
                          class="standing-arrow"
                        />
                        <img
                          src="@static/images/icons/aspn_icon/date_picker/arrow_right_standing_dark.png"
                          v-else-if="['darkWeb', 'darkWebapp'].includes(index)"
                          class="standing-arrow"
                        />
                      </template>
                    </IconMode>
                  </div>
                </div>
              </div>

              <div>
                <div
                  v-show="rankingTable.isLoading"
                  class="skeleton-table__wrapper"
                >
                  <div
                    class="display-flex-sb mb-1rem"
                    v-for="(o, index) in 10"
                    :key="index"
                  >
                    <div class="skeleton-child skeleton-table__left"></div>
                    <div class="skeleton-child skeleton-table__right"></div>
                  </div>
                </div>
                <!-- <Loading v-show="rankingTable.isLoading"></Loading> -->
                <MatchTable
                  :isShowTabs="false"
                  :type="'total'"
                  :matchTableListData="matchTableList"
                  v-show="!rankingTable.isLoading && rankingTable.isShow"
                >
                </MatchTable>
              </div>
            </div>

            <!-- desktop-news -->
            <div class="content-wrapper mt-15rem">
              <div class="content-title">
                {{ $t("NEWS") }}
              </div>

              <div
                class="news-list"
                v-if="topStoriesList.news && topStoriesList.news.length !== 0"
              >
                <template
                  v-for="(item, index) in topStoriesList.news"
                  :key="index"
                >
                  <router-link
                    :to="{
                      name: 'newsDetail',
                      params: {
                        title: item.urlName,
                        id: item.id,
                        currentSportType: item.sportTypePath,
                      },
                    }"
                    v-if="index < 5"
                    tag="div"
                    class="news-item"
                    :class="{ first: index === 0 }"
                  >
                    <div class="news-image">
                      <img
                        class="news-image--coverImg"
                        :src="`${s3ImgUrl}/${item.coverImage}`"
                      />
                    </div>
                    <div class="news-content">
                      <div class="news-title">
                        {{ item.title }}
                      </div>
                      <div class="news-date">
                        {{ item.publishedOn }}
                      </div>
                    </div>
                  </router-link>
                </template>
              </div>
              <NoData v-else />
            </div>
            <!-- Ads -->
            <!-- <StickyAppBanner pos="isSticky" /> -->
          </div>
          <!-- end desktop ranking table -->
        </div>
      </div>
    </div>

    <!-- hide mobile league filter (remove v-if)-->
    <div
      class="match-filter__icon-float__wrapper"
      v-if="false"
      :class="{
        activated: isShowFloatingFilter,
        selected: matchListParams.leagueIdList.length > 0,
      }"
      @click="selectMatch()"
    >
      <svg
        width="18"
        height="17"
        viewBox="0 0 18 17"
        class="match-filter__icon-float__icon"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.36487 16.2769V8.41493L0.193006 1.24045C-0.137298 0.834415 -0.100185 0 0.75341 0H17.2167C18.0183 0 18.2039 0.737564 17.7771 1.24045L11.7536 8.22495V12.7083C11.7536 12.9318 11.6794 13.1217 11.4901 13.2707L7.63784 16.8394C7.19248 17.1709 6.36487 16.9921 6.36487 16.2769ZM4.40122 4L7.67866 7.62522C7.79 7.77422 7.86423 7.92695 7.86423 8.1132V14.5857L10.258 12.4065V7.9642C10.258 7.77794 10.3322 7.62522 10.4436 7.47621L13.5688 4H4.40122Z"
        />
      </svg>
    </div>
    <!-- end desktop -->
  </div>
  <!-- <Toastr ref="toastr" :text="'FILTER_UPDATED'" ></Toastr> -->
  <ModalSubscription ref="modalSubscription"></ModalSubscription>
  <ModalforApp ref="modalPopupRef" isModal="false" />
  <SplashSceenMobile></SplashSceenMobile>

  <WalkThroughModal
    ref="walkThroughRef"
    @closeWalkThroughModal="listenCloseWalkThroughModalEvent"
  />
</template>

<script>
// @ is an alias to /src
import MatchContent from "@/components/MatchContent3.vue";
import SplashSceenMobile from "@/components/mobile/SplashSceen.vue";

import WeeklyCalendar from "@/components/WeeklyCalendar.vue";
import ModalSubscription from "@/components/modal/Subscription.vue";
import Toastr from "@/components/toastr/Toastr.vue";
import { DatePicker } from "@/lib/v-calendar";
import ModalPopup from "@/components/modal/ModalPopup.vue";
import ModalforApp from "@/components/modal/ModalforApp.vue";
import StickyAppBanner from "@/components/modal/StickyAppBanner.vue";
import WalkThroughModal from "@/views/fav/WalkThrough.vue";
import FeaturedMatchListContent from "@/components/home/FeaturedMatchListContent.vue";

import $ from "jquery";

import { mapState, mapGetters, mapActions } from "vuex";
import moment from "moment";
import MatchTable from "@/components/match/football/TableHome.vue";
import Banner from "@/components/Banner.vue";
import config from "@/js/config.js";

import Filter from "@/components/match/Filter.vue";
import { ref } from "vue";
import { sharedState } from "../../../js/sharedState/index";

let hideToggleElement;
let hideToggleTarget;

let count = 0;

let isScrolling;
export default {
  name: "Home",
  components: {
    MatchContent,
    MatchTable,
    WeeklyCalendar,
    Banner,
    ModalSubscription,
    Toastr,
    DatePicker,
    ModalPopup,
    SplashSceenMobile,
    WalkThroughModal,

    ModalforApp,
    StickyAppBanner,
    Filter,

    FeaturedMatchListContent,
  },
  data() {
    return {
      s3ImgUrl: config.s3ImgUrl,
      isFirstimeLoadMontlyCalendar: false,
      displayDateFormat: config.displayDateFormat,
      displayCNDateFormat: config.displayCNDateFormat,
      apiParamDateFormat: config.apiParamDateFormat,
      cnLocaleList: config.cnLocaleList,
      montlyCalender: {
        date: "",
        enDate: "",
        selected: false,
        isFirstime: false,
      },
      montlyCalenderModel: "",
      currentDate: "",
      mobile: {
        isSelectSportType: false,
        currentSportType: {},
        isSelectMatch: false,
        isSelectMatch2: false,
        isSelectedMatchChild: false,
      },
      matchList2: {
        soccerLeagues: [],
      },
      sportType: [
        {
          id: 1,
          name: "Football",
          selected: true,
        },
        {
          id: 2,
          name: "Hockey",
          selected: false,
        },
        {
          id: 3,
          name: "Basketball",
          selected: false,
        },
        {
          id: 4,
          name: "Cricket",
          selected: false,
        },
      ],
      league: {
        isLoading: false,
      },
      leagueList: [],

      filterObj: [],
      cloneFilterObj: [],
      selectedLeagueList: [],
      matchListParams: {
        leagueIdList: [],
        date: "",
      },

      selectLeagueLevel2: "",
      leagueListRankingTable: [],

      currentSelectedLeagueListRankingTable: "",
      matchTableList: [],
      matchRankingTableParams: "",
      rankingTable: {
        isShow: false,
        isShowArrow: true,
        isLoading: false,
        currentSelectedLeagueIndex: 0,
        list: [],
        currentSelectedLeague: "",
      },

      filter_search_txt: "",
      filter_search_txt_mobile: "",
      searchCountryListMobile: [],
      searchLeagueListMobile: [],
      isFilterSearchFoucs: false,

      isCallMatchContentInterval: false,
      matchContentInterval: null,

      callByDateWeekly: false,

      isLiveOnlyMatch: false, //default not show live match

      isShowFloatingFilter: true,
      isShowFavList: false,

      newsLangSelect: {
        selectedLangObj: null,
        isShowList: false,
        msInstance: null,
      },
      currentNewsSportType: "ALL",
      newsCateogoriesList: [],
      topStoriesList: {},
      firstTimeSetNewCurrentDate: true,

      featuredMatchList: [],
      featureMatchTimer: {},
      featureMatchInterval: null,
    };
  },

  computed: {
    ...mapState(["themeMode"]),
    ...mapGetters([
      "isMobile",
      "currentLocale",
      "currentLanguageObj",
      "currentSportType",
      "homePageLeagueParams",
      "userInfo",
      "isLogin",
      "isFavModelChange",
      "themeModeIndex",
      "isMobileRealTime",
    ]),
  },
  watch: {
    matchListParams: {
      deep: true,
      handler(newVal, oldVal) {
        // this.getLeagueListForRankingTable(newVal.leagueIdList);
      },
    },
    currentLocale: {
      deep: true,
      handler(newVal, oldVal) {
        let isGetNewData = true;
        this.init(isGetNewData);
        // this.getLeagueListForRankingTable(newVal.leagueIdList);
      },
    },
    montlyCalenderModel: {
      deep: true,
      handler(newVal, oldVal) {
        if (!this.isFirstimeLoadMontlyCalendar && !this.callByDateWeekly) {
          if (typeof hideToggleElement !== "undefined") {
            setTimeout(() => hideToggleElement({ ref: hideToggleTarget }), 500); // noob fix vcalendar bug (somethimes dont close the calendar automatic);
          }

          this.syncMonthlyWeeklyCalendar(newVal === null ? oldVal : newVal);
        } else {
          this.syncMonthlyWeeklyCalendar(newVal === null ? oldVal : newVal);
          this.callByDateWeekly = false;
        }
        this.isFirstimeLoadMontlyCalendar = false;
      },
    },

    isFavModelChange: {
      deep: true,
      handler(newVal, oldVal) {
        this.commitParamsToMatchContent();
      },
    },
    isLogin: {
      deep: true,
      handler(newVal, oldVal) {
        if (!newVal) {
          this.commitParamsToMatchContent();
        }
      },
    },
    isMobileRealTime(newVal) {
      this.init();
    },
    $route() {
      this.formatMontlyCalender(this.matchListParams.date);
    },
  },
  beforeMount() {
    let sessionCalendarDate = sessionStorage.getItem("calendarDate");
    if (sessionCalendarDate) {
      this.montlyCalenderModel = JSON.parse(sessionCalendarDate);
    }
    window.addEventListener("scroll", this.handleScroll);
  },

  beforeUnmount() {
    clearInterval(this.matchContentInterval);
    clearInterval(this.featureMatchInterval);
    if (this.montlyCalenderModel) {
      sessionStorage.setItem(
        "calendarDate",
        JSON.stringify(this.montlyCalenderModel)
      );
    }
  },

  mounted() {
    this.init();
    window.addEventListener(
      "beforeunload",
      sessionStorage.removeItem("calendarDate")
    );

    // if(this.isMobile) {
    this.$watch(
      () => sharedState.mainUpdate,
      (newVal) => {
        if (newVal === true) {
          let fixedTodayDate = new Date();
          let fullDateDate = fixedTodayDate.getDate();
          let fullDateMonth = fixedTodayDate.getMonth() + 1;
          let fullDateYear = fixedTodayDate.getFullYear();

          if (fullDateMonth < 10) {
            fullDateMonth = `0${fullDateMonth}`;
          }
          if (fullDateDate < 10) {
            fullDateDate = `0${fullDateDate}`;
          }
          let fullDate = `${fullDateYear}-${fullDateMonth}-${fullDateDate}`;
          if (this.monthlyCalendarModel === fullDate) {
            this.syncMonthlyWeeklyCalendar(fullDate);
          }
          this.montlyCalenderModel = fullDate;
          sharedState.mainLogoClicked = false;
        }
        sharedState.mainUpdate = false;
      }
    );
    sharedState.mainUpdate = !sharedState.mainUpdate;
    // }
  },
  methods: {
    ...mapActions([
      "getSoccerLeagueRanking",
      "homePageLeaugeParamsChangeEvent",
      "getLeagueList",
      "getLeagueListFav",
      "getRetrieveUserInfo",
      "setUserData",
      "toastrChangeEvent",
      "commonVerifyLogin",
      "getCountryCodeByIp",
      "currentCountryChangeEvent",
      "getAllNewsList",
      "getFeaturedMatch",
    ]),
    init(isGetNewData) {
      this.commonVerifyLogin();

      //get league filter data
      this.initLeagueFilterAndDate(isGetNewData);

      //get ranking data
      this.getSoccerLeagueRankingData();

      this.commitParamsToMatchContentIntervel();

      this.getRetrieveUserInfoData();

      this.showPopUpNotification();

      this.getAllNewsListData();

      if (!this.isMobile) {
        this.getFeaturedMatchData();
        this.featureMatchInterval = setInterval(() => {
          this.getFeaturedMatchData();
        }, config.intervalMatchList);
      }

      // this.handleClearAllLeagueDesktop(isGetNewData);

      // this.showModalSubscription();
    },

    async getFeaturedMatchData() {
      let params = {
        timeZone: this.$tools.getCurrentTimeZone(),
      };

      const result = await this.getFeaturedMatch(params);
      if (result.errorCode === 0) {
        for (var index in result.result) {
          let item = result.result[index];
          let matchTime = item.matchTime;
          let matchId = item.matchId;
          let matchEnded = item.matchState < 0;
          this.initMatchTime(item); // init date follow language
          if (!this.featureMatchTimer[matchId] && !matchEnded) {
            this.countdownToTime(matchTime, item);
          }
        }
        this.featuredMatchList = result.result;
      }
    },
    countdownToTime(targetTimeString, o) {
      const targetTime = new Date(targetTimeString).getTime();
      const now = new Date().getTime();

      // 如果目标时间已经过去，直接返回
      if (targetTime <= now) {
        this.$emit("countdownFinished", "Time reached!");
        return "Time reached!";
      }

      // 计算初始剩余时间
      let remainingTime = Math.floor((targetTime - now) / 1000);
      // 每秒更新倒计时
      if (!this.featureMatchTimer[o.matchId]) {
        this.featureMatchTimer[o.matchId] = {};
      }
      this.featureMatchTimer[o.matchId]["interval"] = setInterval(() => {
        const currentTime = new Date().getTime();
        remainingTime = Math.floor((targetTime - currentTime) / 1000);

        if (remainingTime <= 0) {
          clearInterval(this.featureMatchTimer[o.matchId]["interval"]);
          delete o["remainingTime"];
          delete this.featureMatchTimer[o.matchId];
        } else {
          let timeFormat = this.initTimeFormat(remainingTime);
          this.featureMatchTimer[o.matchId]["remainingTime"] = timeFormat;
          o["remainingTime"] = this.initTimeFormat(timeFormat);
        }
      }, 1000);
      // return o['remainingTime'];
    },
    initTimeFormat(seconds) {
      const hours = String(Math.floor(seconds / 3600)).padStart(2, "0");
      const minutes = String(Math.floor((seconds % 3600) / 60)).padStart(
        2,
        "0"
      );
      const secs = String(seconds % 60).padStart(2, "0");
      return `${hours}:${minutes}:${secs}`;
    },

    initMatchTime(item) {
      let options = {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
      };
      let theDate = new Date(item.matchTime);
      if (theDate) {
        item["formattedMatchDate"] = this.$tools.getDateByLocale(
          this.currentLanguageObj.apiParam.replace("_", "-"),
          options,
          theDate
        );
      }
    },
    async getAllNewsListData(sportType = "SOCCER") {
      if (!this.isLogin && !this.userCountryCode) {
        let result = await this.getCountryCodeByIp();
        if (result.message === "Success") {
          let countryCode = result.result.countryCode;

          // this.SET_USER_COUNTRY_CODE(countryCode);

          this.currentCountryChangeEvent(countryCode);
        }
      }

      let params = {
        language: this.currentLanguageObj.locale,
        sportType: sportType,
      };

      this.isShowNoData = false;
      this.isLoading = true;

      const result = await this.getAllNewsList(params);

      this.isLoading = false;

      //reset news data variable
      this.newsCateogoriesList = [];
      this.topStoriesList = [];

      let data = result.result;
      if (data && data.length > 0) {
        for (let i = 0; i < data.length; i++) {
          data[i].urlName = data[i].name.toLowerCase().replace(/\s/g, "-");
          for (let x = 0; x < data[i].news.length; x++) {
            let convertedDate;
            let A = moment(data[i].news[x].publishedOn);
            let B = moment();
            let diffDays = A.diff(B, "days");

            if (diffDays > 0) {
              convertedDate = moment(data[i].news[x].publishedOn).fromNow();
            } else {
              convertedDate = moment(data[i].news[x].publishedOn).format(
                "dddd D MMM YYYY"
              );
            }
            let theNewsData = data[i].news[x];
            if (theNewsData.sportType == "SOCCER") {
              theNewsData.sportTypePath = "football";
            } else {
              theNewsData.sportTypePath = theNewsData.sportType.toLowerCase();
            }
            data[i].news[x].urlName = data[i].news[x].title
              .toLowerCase()
              .replace(/\s/g, "-");
            data[i].news[x].publishedOn = moment(
              data[i].news[x].publishedOn
            ).fromNow(); //moment("2019-09-10T07:53:06.000+00:00").fromNow(); //
          }
        }

        this.topStoriesList = data[0];
        if (this.topStoriesList.news.length > 3) {
          this.isShowTopStoriesSwiper = true;
        } else {
          this.isShowTopStoriesSwiper = false;
        }

        data.shift();

        this.newsCateogoriesList = data;
      } else {
        this.isShowNoData = true;
      }
    },
    showPopUpNotification() {
      if (!this.isMobile) {
        this.$refs.modalPopupRef.handleOpen();
      }
    },
    selectByDateWeekly(e) {
      this.callByDateWeekly = true;
      this.syncMonthlyWeeklyCalendar(e.fullDate);
    },

    isOverWeeklyDateRange(e) {
      this.montlyCalender.selected = e;
    },

    initLeagueFilterAndDate(isGetNewData) {
      this.league.isLoading = true;
      setTimeout(() => {
        this.league.isLoading = false;
      }, 100);
      let date = sessionStorage.getItem("calendarDate")
        ? JSON.parse(sessionStorage.getItem("calendarDate"))
        : new Date();
      let sessionStorageMatchesPage =
        sessionStorage.getItem("matchesPage") === null
          ? null
          : JSON.parse(sessionStorage.getItem("matchesPage"));

      if (isGetNewData) {
        this.matchListParams.date = date;
        this.getLeagueListData();
        this.filter_search_txt = "";
        this.matchListParams.leagueIdList = [];
      } else {
        if (sessionStorageMatchesPage !== null) {
          if (
            this.currentLanguageObj.locale === sessionStorageMatchesPage.lang
          ) {
            this.filterObj = sessionStorageMatchesPage.filterObj;
            let result = this.filterObj;

            for (let level1 = 0; level1 < result.length; level1++) {
              for (
                let level2 = 0;
                level2 < result[level1].countries.length;
                level2++
              ) {
                this.filterObj[level1].countries[level2].tickSelect = false; // for desktop version filter to differential is expand the country tab or select all country list (tick select)
                this.filterObj[level1].countries[
                  level2
                ].isFilteredSelected = true; //to differential is to show by seaching filter
                for (
                  let level3 = 0;
                  level3 <
                  result[level1].countries[level2].soccerLeagues.length;
                  level3++
                ) {
                  let level3Obj =
                    this.filterObj[level1].countries[level2].soccerLeagues[
                      level3
                    ];
                  level3Obj.searchKey =
                    this.filterObj[level1].countries[level2]
                      .countryDisplayName +
                    " " +
                    level3Obj.name; // add search key so that can search with country and league name together
                  level3Obj.isFilteredSelectedChild = true;
                }
              }
            }

            this.matchListParams = sessionStorageMatchesPage.matchListParams;

            date = this.matchListParams.date;
          } else {
            this.matchListParams.date = date;
            this.getLeagueListData();
          }
        } else {
          this.matchListParams.date = date;
          this.getLeagueListData();
        }
      }

      this.isFirstimeLoadMontlyCalendar = true;
      this.syncMonthlyWeeklyCalendar(date);
    },

    monthlyCalendarHandle(e, date, toggle, hideToggle) {
      toggle({ ref: e.target });

      hideToggleTarget = e.target;
      hideToggleElement = hideToggle;
    },
    // get user info
    async getRetrieveUserInfoData() {
      if (this.isLogin) {
        let params = {
          token: this.userInfo.token,
          timeZone: this.$tools.getCurrentTimeZone(),
        };
        const result = await this.getRetrieveUserInfo(params);
        this.setUserData(result.result.data);
        this.$refs.walkThroughRef.init();
      }
    },
    formatMontlyCalender(date) {
      if (date) {
        this.montlyCalender.enDate = JSON.parse(JSON.stringify(date));
      }
      if (this.cnLocaleList.includes(this.currentLocale)) {
        this.montlyCalender.date = moment(date).format(
          this.displayCNDateFormat
        ); //for montly calendar usage
      } else {
        this.montlyCalender.date = moment(date).format(this.displayDateFormat); //for montly calendar usage
      }
    },
    syncMonthlyWeeklyCalendar(date) {
      this.$nextTick(() => {
        this.formatMontlyCalender(date);
      });
      let gg = this.montlyCalender.date;

      this.currentDate = moment(date).format(this.apiParamDateFormat); //for weekly calendar usage

      this.montlyCalenderModel = date;

      this.matchListParams.date = this.currentDate;

      this.isLiveOnlyMatch = false;

      this.commitParamsToMatchContent();
      if (this.firstTimeSetNewCurrentDate) {
        this.firstTimeSetNewCurrentDate = false;
      } else {
        this.$refs.weeklyCalendar?.setNewCurrentDate(this.currentDate);
      }
    },
    //end montly calendar

    handleFilterSearch() {
      let isAnyChildMatch = false;
      let result = this.filterObj;
      let targetText = this.filter_search_txt.trim().toUpperCase();

      for (let level1 = 0; level1 < this.filterObj.length; level1++) {
        for (
          let level2 = 0;
          level2 < this.filterObj[level1].countries.length;
          level2++
        ) {
          // this.filterObj[level1].countries[level2].tickSelected = false;   // for desktop version filter to differential is expand the country tab or select all country list (tick select)
          this.filterObj[level1].countries[level2].isFilteredSelected = true; //to differential is to show by seaching filter
          this.filterObj[level1].countries[level2].selected = false;
          for (
            let level3 = 0;
            level3 <
            this.filterObj[level1].countries[level2].soccerLeagues.length;
            level3++
          ) {
            let level3Obj =
              this.filterObj[level1].countries[level2].soccerLeagues[level3];
            level3Obj.searchKey =
              this.filterObj[level1].countries[level2].countryDisplayName +
              " " +
              level3Obj.name; // add search key so that can search with country and league name together
            //level3Obj.selected = false;
            level3Obj.isFilteredSelectedChild = true;
          }
        }
      }

      if (targetText != "") {
        for (let level1 = 0; level1 < this.filterObj.length; level1++) {
          for (
            let level2 = 0;
            level2 < this.filterObj[level1].countries.length;
            level2++
          ) {
            let level2_Obj = this.filterObj[level1].countries[level2];
            if (
              level2_Obj.countryDisplayName.toUpperCase().search(targetText) >
              -1
            ) {
              level2_Obj.isFilteredSelected = true;
              level2_Obj.selected = true;
            } else {
              isAnyChildMatch = false;
              if (level2_Obj.soccerLeagues.length > 0) {
                for (
                  let level3 = 0;
                  level3 <
                  this.filterObj[level1].countries[level2].soccerLeagues.length;
                  level3++
                ) {
                  if (
                    this.filterObj[level1].countries[level2].soccerLeagues[
                      level3
                    ].searchKey
                      .toUpperCase()
                      .search(targetText) > -1
                  ) {
                    this.filterObj[level1].countries[
                      level2
                    ].isFilteredSelected = true;
                    this.filterObj[level1].countries[level2].selected = true;

                    this.filterObj[level1].countries[level2].soccerLeagues[
                      level3
                    ].isFilteredSelectedChild = true;
                    isAnyChildMatch = true;
                  } else {
                    if (isAnyChildMatch) {
                      this.filterObj[level1].countries[
                        level2
                      ].isFilteredSelected = true;
                      this.filterObj[level1].countries[level2].selected = true;
                      if (
                        this.filterObj[level1].countries[level2].soccerLeagues[
                          level3
                        ].searchKey
                          .toUpperCase()
                          .search(targetText) > -1
                      ) {
                        //this.filterObj[level1].countries[level2].soccerLeagues[level3].isFilteredSelectedChild = true;
                      } else {
                        this.filterObj[level1].countries[level2].soccerLeagues[
                          level3
                        ].isFilteredSelectedChild = false;
                      }
                    } else {
                      this.filterObj[level1].countries[
                        level2
                      ].isFilteredSelected = false;

                      this.filterObj[level1].countries[level2].soccerLeagues[
                        level3
                      ].isFilteredSelectedChild = false;
                    }
                  }
                }
              } else {
                level2_Obj.isFilteredSelected = false;
                level2_Obj.selected = false;
              }
            }
          }
        }
      } else {
        //  this.resetFilterObj();
      }
    },

    handleFilterSearchMobile() {
      let targetText = this.filter_search_txt_mobile.trim().toUpperCase();

      //search for country
      this.searchCountryListMobile = [];
      for (let level1 = 0; level1 < this.filterObj.length; level1++) {
        for (
          let level2 = 0;
          level2 < this.filterObj[level1].countries.length;
          level2++
        ) {
          let level2Obj = this.filterObj[level1].countries[level2];
          if (
            level2Obj.countryDisplayName.toUpperCase().search(targetText) > -1
          ) {
            //search at country level (parent)
            //this.searchCountryListMobile.push(level2Obj);
          }
        }
      }

      this.searchLeagueListMobile = [];
      for (let level1 = 0; level1 < this.filterObj.length; level1++) {
        for (
          let level2 = 0;
          level2 < this.filterObj[level1].countries.length;
          level2++
        ) {
          let level2Obj = this.filterObj[level1].countries[level2];
          for (
            let level3 = 0;
            level3 < level2Obj.soccerLeagues.length;
            level3++
          ) {
            if (
              level2Obj.soccerLeagues[level3].searchKey
                .toUpperCase()
                .search(targetText) > -1
            ) {
              level2Obj.soccerLeagues[level3].countryDisplayName =
                level2Obj.countryDisplayName;

              //push data for country list search
              if (this.searchCountryListMobile.length === 0) {
                this.searchCountryListMobile.push(level2Obj);
              } else {
                if (this.searchCountryListMobile.indexOf(level2Obj) === -1) {
                  this.searchCountryListMobile.push(level2Obj);
                }
              }

              //push data for league list search
              if (!level2Obj.rootFlag) {
                this.searchLeagueListMobile.push(
                  level2Obj.soccerLeagues[level3]
                );
              }
            }
          }
        }
      }
    },

    showModalSubscription() {
      this.$refs.modalSubscription.handleOpen();
    },

    async getLeagueListData() {
      const response = await this.getLeagueList();

      let result = response.result.categories;
      this.filterObj = result;
      this.storeFilterData();
      this.resetFilterObj();

      // for (let level1=0; level1< result.length; level1++){
      //     for (let level2=0; level2 < result[level1].countries.length; level2++) {
      //         this.filterObj[level1].countries[level2].tickSelect = false;   // for desktop version filter to differential is expand the country tab or select all country list (tick select)
      //         this.filterObj[level1].countries[level2].isFilteredSelected = true;  //to differential is to show by seaching filter
      //         for (let level3=0; level3 < result[level1].countries[level2].soccerLeagues.length; level3++) {
      //             let level3Obj = this.filterObj[level1].countries[level2].soccerLeagues[level3];
      //             level3Obj.searchKey = this.filterObj[level1].countries[level2].countryDisplayName + ' ' +level3Obj.name; // add search key so that can search with country and league name together
      //             level3Obj.isFilteredSelectedChild = true;
      //         }
      //     }
      // }

      for (let i = 0; i < result.length; i++) {
        for (let x = 0; x < result[i].countries.length; x++) {
          this.leagueList.push(result[i].countries);
        }
      }
    },
    //desktop league filter
    selectCountry(o, level2) {
      level2.selected = !level2.selected;
    },

    resetFilterObj() {
      // this.filter_search_txt = "";
      for (let level1 = 0; level1 < this.filterObj.length; level1++) {
        for (
          let level2 = 0;
          level2 < this.filterObj[level1].countries.length;
          level2++
        ) {
          this.filterObj[level1].countries[level2].tickSelected = false; // for desktop version filter to differential is expand the country tab or select all country list (tick select)
          this.filterObj[level1].countries[level2].isFilteredSelected = true; //to differential is to show by seaching filter
          this.filterObj[level1].countries[level2].selected = false;
          for (
            let level3 = 0;
            level3 <
            this.filterObj[level1].countries[level2].soccerLeagues.length;
            level3++
          ) {
            let level3Obj =
              this.filterObj[level1].countries[level2].soccerLeagues[level3];
            level3Obj.searchKey =
              this.filterObj[level1].countries[level2].countryDisplayName +
              " " +
              level3Obj.name; // add search key so that can search with country and league name together
            level3Obj.selected = false;
            level3Obj.isFilteredSelectedChild = true;
          }
        }
      }
    },

    handleClearAllLeagueDesktop(isGetNewData) {
      this.filter_search_txt = "";
      this.resetFilterObj();

      this.matchListParams.leagueIdList = [];
      this.commitParamsToMatchContent();
    },

    selectAllLeagueByCountry(o, level2) {
      level2.tickSelected = !level2.tickSelected;

      if (!level2.tickSelected) {
        //remove selected league

        for (let i = 0; i < level2.soccerLeagues.length; i++) {
          if (level2.soccerLeagues[i].isFilteredSelectedChild) {
            let index = this.matchListParams.leagueIdList.indexOf(
              level2.soccerLeagues[i].leagueId
            );

            if (index !== -1) {
              this.matchListParams.leagueIdList.splice(index, 1);
            }

            level2.soccerLeagues[i].selected = level2.tickSelected;
          }
        }
      } else {
        //add selected league
        for (let i = 0; i < level2.soccerLeagues.length; i++) {
          if (level2.soccerLeagues[i].isFilteredSelectedChild) {
            let index = this.matchListParams.leagueIdList.indexOf(
              level2.soccerLeagues[i].leagueId
            );
            if (index === -1) {
              //alreay at the array list so no need to push it
              this.matchListParams.leagueIdList.push(
                level2.soccerLeagues[i].leagueId
              );
            }
            level2.soccerLeagues[i].selected = level2.tickSelected;
          }
        }
      }
      this.commitParamsToMatchContent();
    },

    selectLeague(o, level2, level3) {
      let index = this.matchListParams.leagueIdList.indexOf(level3.leagueId);
      if (index !== -1) {
        this.matchListParams.leagueIdList.splice(index, 1);
      } else {
        this.matchListParams.leagueIdList.push(level3.leagueId);
      }
      level3.selected = !level3.selected;

      //sync child league list and parent
      let count = 0;
      for (let i = 0; i < level2.soccerLeagues.length; i++) {
        if (level2.soccerLeagues[i].selected) {
          count++;
        }
      }
      if (level2.soccerLeagues.length === count) {
        level2.tickSelected = true;
      } else {
        level2.tickSelected = false;
      }

      this.commitParamsToMatchContent();
    },

    handleFinishSelectLeagueDesktop() {
      this.commitParamsToMatchContent();
    },
    //end desktop league filter

    selectMatch() {
      this.filter_search_txt_mobile = "";
      this.mobile.isSelectMatch = !this.mobile.isSelectMatch;
      for (let i = 0; i < this.filterObj.length; i++) {
        for (let x = 0; x < this.filterObj[i].countries.length; x++) {
          for (
            let y = 0;
            y < this.filterObj[i].countries[x].soccerLeagues.length;
            y++
          ) {
            if (
              this.filterObj[i].countries[x].soccerLeagues[y].selected === true
            ) {
              this.selectedLeagueList.push(
                this.filterObj[i].countries[x].soccerLeagues[y].leagueId
              );
            }
          }
        }
      }
    },

    clearAllSelectMatchChild() {
      this.filter_search_txt_mobile = "";
      for (let i = 0; i < this.filterObj.length; i++) {
        for (let x = 0; x < this.filterObj[i].countries.length; x++) {
          this.filterObj[i].countries[x].selected = false;
          this.filterObj[i].countries[x].tickSelected = false;
          for (
            let y = 0;
            y < this.filterObj[i].countries[x].soccerLeagues.length;
            y++
          ) {
            this.filterObj[i].countries[x].soccerLeagues[y].selected = false;
          }
        }
      }
      this.matchListParams.leagueIdList = [];
    },

    selectMatchChildAll(o, level2) {
      level2.selected = !level2.selected;

      if (!level2.selected) {
        //remove selected league

        for (let i = 0; i < level2.soccerLeagues.length; i++) {
          let index = this.matchListParams.leagueIdList.indexOf(
            level2.soccerLeagues[i].leagueId
          );

          if (index !== -1) {
            this.matchListParams.leagueIdList.splice(index, 1);
          }
          level2.soccerLeagues[i].selected = level2.selected;
        }
      } else {
        //add selected league
        for (let i = 0; i < level2.soccerLeagues.length; i++) {
          let index = this.matchListParams.leagueIdList.indexOf(
            level2.soccerLeagues[i].leagueId
          );
          if (index === -1) {
            //alreay at the array list so no need to push it
            this.matchListParams.leagueIdList.push(
              level2.soccerLeagues[i].leagueId
            );
          }
          level2.soccerLeagues[i].selected = level2.selected;
        }
      }

      level2.soccerLeagues.forEach((x) => {
        // x.selected = false;
        //this.selectMatchChild2(x)
        // x.selected= level2.selected;
      });
    },

    selectMatchChild(o, level2) {
      this.selectLeagueLevel2 = level2.countryDisplayName;
      this.mobile.isSelectMatch2 = !this.mobile.isSelectMatch2;
      this.matchList2 = level2;
    },

    selectMatchChild2(level2, o) {
      level2.selected = !level2.selected;
      let index = this.matchListParams.leagueIdList.indexOf(level2.leagueId);
      if (level2.selected) {
        // mean need to add selected item to array
        if (index == -1) {
          //if item no yet added to array
          this.matchListParams.leagueIdList.push(level2.leagueId);
        }
      } else {
        if (index !== -1) {
          this.matchListParams.leagueIdList.splice(index, 1);
        }
      }

      // if (index !== -1) {//remove league
      //      this.matchListParams.leagueIdList.splice(index, 1);
      // }else{// add league
      //     this.matchListParams.leagueIdList.push(level2.leagueId)
      // }

      //check if select all child if yes then parent selected to be true;
      this.syncMatchChildAndMatchChild2();
    },

    syncMatchChildAndMatchChild2() {
      let countMatchList2Child = 0;

      for (let i = 0; i < this.matchList2.soccerLeagues.length; i++) {
        if (this.matchList2.soccerLeagues[i].selected == true) {
          countMatchList2Child++;
        }
      }

      if (countMatchList2Child === this.matchList2.soccerLeagues.length) {
        this.matchList2.selected = true;
      } else {
        this.matchList2.selected = false;
      }
    },
    handleFinishSelectLeague() {
      //this.homePageLeaugeParamsChangeEvent(this.matchListParams);
      this.commitParamsToMatchContent();
      this.handleCloseFilter();
    },

    clearAllSelectMatchChild2() {
      for (let i = 0; i < this.matchList2.soccerLeagues.length; i++) {
        let index = this.matchListParams.leagueIdList.indexOf(
          this.matchList2.soccerLeagues[i].leagueId
        );
        if (index !== -1) {
          this.matchListParams.leagueIdList.splice(index, 1);
        }

        this.matchList2.soccerLeagues[i].selected = false;
      }
      this.syncMatchChildAndMatchChild2();
    },

    handleCloseFilter() {
      this.mobile.isSelectMatch = false;
      this.closeSelectMatch2();
      setTimeout(() => {
        let params = {
          isOpen: true,
          msg: "FILTER_UPDATED",
        };

        this.toastrChangeEvent(params);
        // this.$refs.toastr.handleOpen(); //animation more smooth after delay 0.1s
      }, 100);
    },

    closeSelectMatch2() {
      this.mobile.isSelectMatch2 = false;
    },

    selectSportType(o) {
      this.sportType.forEach((x) => {
        x.selected = false;
      });
      o.selected = true;
      this.mobile.currentSportType = o;
      this.selectSportTypeMobile();
    },

    selectSportTypeMobile() {
      this.mobile.isSelectSportType = !this.mobile.isSelectSportType;
    },

    commitParamsToMatchContentIntervel() {
      this.matchContentInterval = setInterval(() => {
        let props = this.matchListParams;

        const theDate = moment(props.date).startOf("day");
        const today = moment().startOf("day");
        const diffDay = theDate.diff(today, "days");

        if (diffDay === 0 || diffDay === -1 || this.isLiveOnlyMatch) {
          this.commitParamsToMatchContentInterval();
        }
      }, 15000); // Previous change by Chew - git hash 6cff767 - 25000, latest by Yim (Justin authorized)
    },

    commitParamsToMatchContentInterval() {
      let matchesPage = {
        filterObj: this.filterObj,
        matchListParams: this.matchListParams,
        language: this.currentLanguageObj.locale,
        lang: this.currentLanguageObj.apiParam,
      };

      this.matchListParams.isCallInterval = true;
      this.isCallMatchContentInterval = true;

      if (this.filterObj.length !== 0) {
        // not first time
        sessionStorage.setItem("matchesPage", JSON.stringify(matchesPage));
      }
      if (this.$refs.matchContentChild) {
        this.$refs.matchContentChild.getMatchListData(this.matchListParams);
      }
      if (this.isLogin && this.$refs.favMatchContentChild) {
        this.$refs.favMatchContentChild.getMatchListData(this.matchListParams);
      }
    },
    storeFilterData() {
      //paramerter for getMatchlist api
      this.matchListParams.isCallInterval = false;
      this.matchListParams.isLiveOnly = this.isLiveOnlyMatch;

      //for localhost store
      let matchesPage = {
        filterObj: this.filterObj,
        matchListParams: this.matchListParams,
        language: this.currentLanguageObj.locale,
        lang: this.currentLanguageObj.apiParam,
      };

      this.isCallMatchContentInterval = false;

      if (this.filterObj.length !== 0) {
        // not first time
        sessionStorage.setItem("matchesPage", JSON.stringify(matchesPage));
      }
    },

    commitParamsToMatchContent() {
      this.storeFilterData();
      if (this.$refs.matchContentChild) {
        this.$refs.matchContentChild.getMatchListData(this.matchListParams);
      }
      if (this.isLogin && this.$refs.favMatchContentChild) {
        this.$refs.favMatchContentChild.getMatchListData(this.matchListParams);
      }
    },

    changeMatchContentEvent(result) {
      if (!this.isMobile) {
        if (result.length === 0) {
          this.rankingTable.isShow = false;
        } else {
          if (!this.isCallMatchContentInterval) {
            // let leagueList = result.map((x) => x.leagueId).join();
            // this.getSoccerLeagueRankingData(leagueList);
          }
        }
      }
    },

    toggleFavList(result) {
      this.isShowFavList = result.length > 0 ? true : false;
    },

    async getSoccerLeagueRankingData(param) {
      //this.rankingTable.isShow= true;
      this.rankingTable.isLoading = true;
      let params = {
        leagueIdList: "",
      };
      const result = await this.getSoccerLeagueRanking(params);
      this.getLeagueListForRankingTable(result.result);
      this.rankingTable.isLoading = false;
    },

    //handle ranking table
    getLeagueListForRankingTable(result) {
      if (result.length === 0) {
        this.rankingTable.isShow = false;
      } else {
        this.rankingTable.isShow = true;
        this.rankingTable.list = result;
        this.handleLeagueListRankingTable();
      }
    },

    handleLeagueListRankingTable(action) {
      let limit = this.rankingTable.list.length - 1;
      let index = 0;
      if (limit === 0) {
        this.rankingTable.isShowArrow = false;
      } else {
        this.rankingTable.isShowArrow = true;
      }
      if (action === "next") {
        if (this.rankingTable.currentSelectedLeagueIndex < limit) {
          this.rankingTable.currentSelectedLeagueIndex++;
        } else {
          this.rankingTable.currentSelectedLeagueIndex = 0;
        }
        index = this.rankingTable.currentSelectedLeagueIndex;
      } else if (action === "prev") {
        if (this.rankingTable.currentSelectedLeagueIndex > 0) {
          this.rankingTable.currentSelectedLeagueIndex--;
        } else {
          this.rankingTable.currentSelectedLeagueIndex = limit;
        }

        index = this.rankingTable.currentSelectedLeagueIndex;
      } else {
        index = 0;
      }

      this.rankingTable.currentSelectedLeague =
        this.rankingTable.list[index].tableName;
      this.matchTableList = this.rankingTable.list[index];
    },

    //live match
    handleLiveMatch() {
      this.isLiveOnlyMatch = !this.isLiveOnlyMatch;

      this.handleWeeklyCalanderWithLiveMatch();

      if (this.isLiveOnlyMatch) {
        //if show live match
        this.commitParamsToMatchContent();
      } else {
        this.commitParamsToMatchContent();
      }
    },

    handleWeeklyCalanderWithLiveMatch() {
      //if show live match weekly calendar deselected all date, otherwise show previous date
      this.weeklyCalendarData = {
        currentDate: this.currentDate,
        isLiveOnlyMatch: this.isLiveOnlyMatch,
      };
    },

    //handle scroll (when scrolling down it will disappear, when stop scrolling it will appear, by default it is fixed appearance)
    handleScroll(event) {
      if (event.type === "scroll") {
        this.isShowFloatingFilter = false;
      } else {
        this.isShowFloatingFilter = true;
      }

      // Clear our timeout throughout the scroll
      window.clearTimeout(isScrolling);

      // Set a timeout to run after scrolling ends
      isScrolling = setTimeout(() => {
        this.isShowFloatingFilter = true;
      }, 300);
    },

    //walkthrough
    listenCloseWalkThroughModalEvent() {
      this.commitParamsToMatchContent();
      if (!this.isMobile) {
        this.$refs.filterRef.init();
      }
    },
    isToday(date) {
      // 获取当前日期
      const today = new Date();

      const targetDate = new Date(date);

      const isToday =
        today.getFullYear() === targetDate.getFullYear() &&
        today.getMonth() === targetDate.getMonth() &&
        today.getDate() === targetDate.getDate();

      return isToday;
    },
    datePickerDate(date) {
      return date.split(" ")[0] + " " + date.split(" ")[1];
    },
    changeDate(type) {
      const targetDate = new Date(this.montlyCalender.enDate);
      const options = { year: "numeric", month: "short", day: "2-digit" };
      let formattedDate = "";

      if (type === "prev") {
        const yesterday = new Date(targetDate);
        yesterday.setDate(targetDate.getDate() - 1);
        formattedDate = yesterday.toLocaleDateString("en-GB", options);
      } else if (type === "next") {
        const tomorrow = new Date(targetDate);
        tomorrow.setDate(targetDate.getDate() + 1);
        formattedDate = tomorrow.toLocaleDateString("en-GB", options);
      }
      // this.$refs.weeklyCalendar.initCalendar()
      this.montlyCalenderModel = formattedDate;
    },
    updateFav({ o, level2, to }) {
      if (to === "toFav") {
        this.$refs.favMatchContentChild.updateFavData({
          o: o,
          level2: level2,
        });
      } else if (to === "toList") {
        this.$refs.matchContentChild.updateFavData({
          o: o,
          level2: level2,
        });
      }
    },
  },
};
</script>

<style scoped>
.date {
  background-color: black;
}
.home-nav__match-wrapper {
  display: block;
}

.match-filter__date {
  text-transform: capitalize;
}
.match-filter {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0.8rem;
}
.match-filter__right-wrapper {
  display: flex;
  align-items: center;
  margin-left: 7.2rem;
  position: relative;
}
.match-filter__right-divider {
  width: 100%;
  height: 0.1rem;
  background-color: black;
}
.match-filter__icon_wrapper {
  width: 1.5rem;
  height: 1.5rem;
  /* padding: .3rem; */
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.3rem;
}
.match-filter__icon_wrapper.selected {
  background-color: #6f8c9b;
}
.match-table__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.88rem;
  margin-bottom: 0.4rem;
}
.match-table__header-country {
  font-size: 0.88rem;
}
.match-table__header-country__seperator {
  margin: 0 0.3rem;
}
.match-content__wrapper {
  width: 36rem;
  margin: 0 24px;
  box-sizing: border-box;
  /* padding: 1rem; */
  border-radius: 16px;
  /* background: var(--color-background-default-secondary); */
  /* background-color: red; */
}
.match-fav-content__wrapper {
  margin-bottom: 1rem !important;
}
.match-country__wrapper {
  width: 13.5rem;
}
.match-country__header {
  font-size: 10px;
  margin-bottom: 0.3rem;
}
.match-country__clear-all {
  font-size: 10px;
  margin-right: 1rem;
  cursor: pointer;
  margin-bottom: 0.3rem;
  color: var(--color-grey-light);
}
.match-country__clear-all:hover {
  color: var(--color-hover);
}
.match-country__body-wrapper {
  margin-bottom: 0.3rem;
}
.match-country__body-menu {
  display: flex;
  align-items: center;
  font-size: 11.2px;
  cursor: pointer;
}
.match-country__body-menu > img {
  margin-right: 0.3rem;
  width: 1.35rem;
}
.match-country__body-menu__arrow {
  -webkit-transition: -webkit-transform 0.2s ease;
  transition: -webkit-transform 0.2s ease;
  transition: transform 0.2s ease;
  transition: transform 0.2s ease, -webkit-transform 0.2s ease;
}
.match-country__body-menu__arrow.selected {
  transform: rotate(180deg);
}
.match-country__body-menu__tick {
  cursor: pointer;
  width: 1rem;
  height: 1rem;
  margin-right: 0.5rem;
  background: url("../../../../static/images/icons/icon_filter_tick_unselect.png")
    center/cover no-repeat;
}
.match-country__body-menu__tick.selected {
  background: url("../../../../static/images/icons/icon_filter_tick_selected.png")
    center/cover no-repeat;
}
.match-country__body-menu__name {
  width: 7.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  white-space: nowrap;
}
.match-country__body-menu__name:hover {
  color: var(--color-hover);
}
.match-country__body-menu__sub {
  margin-left: 1.7rem;
  font-size: 11.2px;
  color: #abbcc4;
}
.match-country__body-menu__sub > a {
  margin: 0.5rem 0;
  display: block;
  cursor: pointer;
}
.match-country__body-menu__sub-container {
  display: flex;
  margin-top: 0.5rem;
  align-items: center;
  cursor: pointer;
}
.match-country__apply {
  margin: 0.5rem 0 0.8rem 0;
}
.match-table__wrapper {
  width: 22.5rem;
  position: relative;
}
.match-table__title-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.88rem;
  margin-bottom: 16px;
  padding: 12px 0;
}
.match-table__title-country {
  display: flex;
  width: 12rem;
  line-height: 1rem;
}
.match-table__title-country-container {
  transition: all 0.3s;
  min-width: 100%;

  font-size: 11.2px;
  text-align: center;
  color: var(--color-text-default-default);
  font-family: var(--weight-600);
}
.match-table__title-arrow__wrapper {
  width: 2rem;
  text-align: right;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.match-table__title-arrow__icon {
  fill: white;
}
.match-table__title-arrow__wrapper:hover .match-table__title-arrow__icon {
  fill: var(--color-hover);
}
.match-table__title-arrow__wrapper.tl {
  text-align: left;
}
.mobile-special-event-container {
  display: grid;
  margin: 0.8rem;
  gap: 10px;
  grid-template-columns: repeat(2, 1fr);
}
::v-deep(.icon-calender) {
  width: 64px;
  margin-left: 12px;
  cursor: pointer;
}
@media (min-width: 768px) {
  .match-filter {
    margin: 0.8rem 0;
    justify-content: unset;
  }
  .match-filter__date {
    width: 13rem;
  }
  .match-content__wrapper {
    width: 37rem;
    margin-right: 1.5rem;
  }
}
@media (max-width: 768px) {
  /* for test */

  .match-fav-content__wrapper {
    margin-bottom: 0 !important;
  }
  .match-content__wrapper {
    width: 100% !important;
    margin: 0;
    padding: 0 8px;
    background: none;
  }
  ::v-deep(.icon-calender) {
    width: 20px;
    margin-left: 12px;
  }
  .match-fav-content__wrapper {
    width: 100% !important;
    margin: 0;
    padding: 0 8px;
  }
}

.date-value {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.date-value .bold {
  margin-right: 8px;
  font-family: var(--weight-600);
  font-weight: normal;
}
.icon-arrow {
  width: 24px;
}
.arrow-left {
  margin-right: 31.5px;
}
.arrow-right {
  margin-left: 31.5px;
}
.match-filter__live-container {
  background-color: var(--color-background-default-secondary);
  padding: 16px 32px;
  border-radius: var(--size-radius-400);
  display: flex;
  align-items: center;
  color: var(--color-text-default-default);
}
</style>

<style scoped>
.match-filter__live-container .match-filter__date {
  width: 100% !important;
}

.match-filter__live-container {
  margin: 0 24px;
  width: 37rem;
  box-sizing: border-box;
}
.match-filter__live-container .match-filter__live {
  width: 64px !important;
  height: 38px !important;
}
.match-filter__live-container .match-filter__live.selected {
  /* background: var(--gray-200) !important; */
  color: #000;
  text-transform: uppercase;
  line-height: 38px;
  text-align: center;
  border-radius: 16px;
  font-family: var(--weight-700);
  letter-spacing: 1px;
}
.match-filter__live-container .match-filter__live-wrapper {
  margin-left: 0;
  margin-right: 14px;
}
.calendar-container {
  border-bottom: 0;
}
.home-match-filter {
  margin-bottom: 16px !important;
  margin-top: 0;
}
.home-match__standing-table {
  width: 100%;
}
.home-match__standing-table .match-table__title-country {
  width: 100%;
}
.match-table-standing-wrapper {
  padding: 16px;
  box-sizing: border-box;
  border-radius: 16px;
  background-color: var(--color-background-default-secondary);
}
.standing-arrow {
  width: 24px;
}
.home-match__standing-table .match-table__title-country-container {
  font-size: 16px;
  letter-spacing: 0.64px;
}
.content-wrapper {
  width: 360px;
  padding: 16px;
  box-sizing: border-box;
  border-radius: 16px;
  background-color: var(--color-background-default-secondary);
  margin-bottom: 24px;
}
.content-title {
  font-family: var(--weight-700);
  font-size: var(--typography-heading-size-extra-small);
  margin-bottom: 1rem;
  color: var(--color-text-default-default);
}

.news-list {
}
.news-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
}
.news-image {
  display: inherit;
}
.news-image--coverImg {
  width: 128px;
  border-radius: 8px;
  height: 72px;
  object-fit: cover;
}
.news-item.first .news-image--coverImg {
  width: 100%;
  height: 184.5px;
}
.news-content {
}

.news-title {
  font-size: var(--typography-body-size-small);
  font-family: var(--weight-600);
  margin-bottom: 4px;
  /* word-break: break-all; */
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  letter-spacing: 0.64px;
  color: var(--color-text-default-default);
}
.news-date {
  color: var(--color-text-default-secondary);
  font-size: var(--typography-caption-size-large);
  letter-spacing: 0.2px;
}

.news-item:nth-child(1) {
  display: block;
}
.news-item:nth-child(1) .news-image--coverImg {
  width: 100%;
  /* height: 184.5px; */
}
.news-item:nth-child(1) .news-content {
  margin-top: 8px;
}

.mt-1rem {
  margin-top: 1rem;
}

@media (max-width: 768px) {
  /* for test */

  .match-filter__live-container {
    margin: 0;
    width: 100%;
    box-sizing: border-box;
    border-radius: 0;
    padding: 8px;
    border-bottom: 1px solid var(--color-border-default-default);
  }
  .home-match-filter {
    margin: 0;
  }
  .home-page-container {
    padding-top: 0;
  }
  .match-filter__live-container
    .match-filter__live-wrapper
    .match-filter__live {
    /* background: var(--color-background-default-secondary); */
    color: var(--color-text-default-default);
    width: 50px;
    text-transform: uppercase;
    line-height: 38px;
    border-radius: 8px;
    text-align: center;
  }
  .match-filter__live-container
    .match-filter__live-wrapper
    .match-filter__live.selected {
    /* background: var(--error-500) !important; */
    color: #fff;
  }
  .mobile-calander {
    margin-left: auto;
  }
  .match-table__wrapper {
    display: none;
  }
}
</style>

<style>
.vc-container .vc-weekday {
  color: var(--gray-400);
  font-size: 10px;
  font-family: var(--weight-400);
  font-weight: normal;
}
.vc-is-dark .vc-container .vc-weekday {
  color: var(--gray-600);
}
</style>
